import HttpUtils from '@/framework/HttpUtils';
import { handelPromise } from '@/utils';
//获取游戏列表
export const getGameList = async (): Promise<DappVo[]> => {
    return await handelPromise<any>(HttpUtils.Get('/dapp/dappListings'));
};
//获取游戏详情
export const getDappInfo = async (dappNo: string): Promise<DappVo> => {
    return await handelPromise<any>(HttpUtils.Get('/dapp/dappInfo', { dappNo }, { DAppNo: dappNo }));
};
//查询是否有可用的门票
export const getUsableTicket = async (dappNo: string): Promise<UsableTicket> => {
    return await handelPromise<any>(HttpUtils.Get('/ticketRecord/getUsableTicket', {}, { DAppNo: dappNo }));
};
//查询是否有订阅应用
export const getIsSubscribe = async (dappNo: string): Promise<GenTicketResp> => {
    return await handelPromise<any>(HttpUtils.Get('/ticketRecord/getIsSubscribe', {}, { DAppNo: dappNo }));
};
//创建凭证
export const createTicket = async (dappNo: string): Promise<GenTicketResp> => {
    return await handelPromise<any>(HttpUtils.Post('/ticketRecord/create', {}, { DAppNo: dappNo }));
};
//更新凭证支付状态
export const updatePadding = async (dappNo: string, ticketNo: string, txHash: string): Promise<GenTicketResp> => {
    return await handelPromise<any>(HttpUtils.Put('/ticketRecord/updatePadding', { ticketNo, txHash }, { DAppNo: dappNo }));
};

//获取凭证支付状态
export const getTicketPayStatus = async (dappNo: string, ticketNo: string): Promise<GenTicketResp> => {
    return await handelPromise<any>(HttpUtils.Get('/ticketRecord/getTicketPayStatus', { ticketNo }, { DAppNo: dappNo }));
};

//订阅应用
export const subscribeDappNo = async (dappNo: string): Promise<GenTicketResp> => {
    return await handelPromise<any>(HttpUtils.Put('/ticketRecord/subscribe', {}, { DAppNo: dappNo }));
};
//查询App权限
export const queryPermission = async (model: string, dappNo: string): Promise<Permission[]> => {
    return await handelPromise<any>(HttpUtils.Get('/dapp/permission/query', { modelCode: model }, { DAppNo: dappNo }));
};
